export default {
  series: 1,
  data: 'Category;Series 1\nA;5000\nB;4000\nC;3000\nD;2000',
};
